import { isEmpty } from 'lodash-es';
import { InsuranceDetailQueries } from '@frontend/api-insurance-detail';
import { useWivTeaserHandler } from '@frontend/self-upgrade';
import { useGetLocationVerticalForPayerList } from './use-get-location-vertical-for-payer-list';

export const useGetInsuranceStatus = (personId: string, locationId: string) => {
  const { isDental, isWellnessVertical } = useGetLocationVerticalForPayerList(locationId);

  const { isLoading: isLoadingWivEligibility, showWeaveVerify } = useWivTeaserHandler({ locationIds: [locationId] });

  const { data: verificationDetailsForDental, isLoading: isLoadingVerificationDetails } =
    InsuranceDetailQueries.useGetDentalInsuranceVerificationDetailsPersonId({
      personId,
      locationId,
      options: {
        enabled: isDental && showWeaveVerify,
      },
    });

  const { data: weaveVerificationDetails, isLoading: isLoadingWeaveVerificationDetails } =
    InsuranceDetailQueries.useGetNonDentalInsuranceVerificationDetailsByPersonId({
      personId,
      locationId,
      options: {
        enabled: !isDental && isWellnessVertical && showWeaveVerify,
      },
    });

  const verificationDetails = isDental ? verificationDetailsForDental : weaveVerificationDetails;
  const status = verificationDetails?.coverage?.thirdPartyCoverage?.coverage?.status;
  const overriddenStatus = verificationDetails?.coverage?.overriddenCoverage?.coverage;
  const hasError = !isEmpty(verificationDetails?.coverage?.thirdPartyCoverage?.errorDetails);
  return {
    status,
    overriddenStatus,
    hasError,
    isLoading: isLoadingVerificationDetails || isLoadingWeaveVerificationDetails || isLoadingWivEligibility,
  };
};
